/** One half-hour slot in the time list, with "start of day" / "noon" / "end of day" beside its landmarks. */
import { formatTimeOfDay, timeSlotNote } from './time-of-day';

export const TIME_SLOT_HEIGHT = 30;

export interface TimeSlotOptionProps {
  minutes: number;
  selected: boolean;
  onPick: (minutes: number) => void;
}

export function TimeSlotOption({ minutes, selected, onPick }: TimeSlotOptionProps) {
  const note = timeSlotNote(minutes);
  return (
    <div
      role="option"
      aria-selected={selected}
      // Mouse-down rather than click, so the pick lands before the field's blur closes the list.
      onMouseDown={(e) => {
        e.preventDefault();
        onPick(minutes);
      }}
      style={{
        height: TIME_SLOT_HEIGHT,
        padding: '0 9px',
        borderRadius: 6,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 12.5,
        fontVariantNumeric: 'tabular-nums',
        cursor: 'pointer',
        fontWeight: selected ? 800 : 500,
        background: selected ? 'var(--nb-primary-soft)' : 'transparent',
        color: selected ? 'var(--nb-primary-2)' : 'var(--nb-ink-2)',
      }}
    >
      <span style={{ flex: 1 }}>{formatTimeOfDay(minutes)}</span>
      {note && (
        <span style={{ fontSize: 10.5, fontWeight: 600, color: 'var(--nb-subtle)' }}>{note}</span>
      )}
    </div>
  );
}
